import { Box, FormControlLabel, Switch, useMediaQuery } from "@mui/material";
import { useTheme } from "@emotion/react";
import WorldCup32TeamsBracket from "./WorldCup32TeamsBracket";
import WorldCup16TeamMobileBracket from "./WorldCupMobileBracket";
import { useSelector } from "react-redux";
import { selectWorldCupResult } from "./WorldCupResultSlice";
import WorldCup16TeamsBracket from "./WorldCup16TeamsBracket";
import WorldCup32TeamMobileBracket from "./WorldCup32TeamsMobileBracket";
import { useState } from "react";

export default function WorldCupBracket() {
    const theme = useTheme();
    const desktopView = useMediaQuery(theme.breakpoints.up("md"));
    const result = useSelector(selectWorldCupResult);
    const [showFullBracket, setShowFullBracket] = useState(false);
    let showFullBracketSwitch;
    if (result.year >= 2026 && !desktopView) {
        showFullBracketSwitch = <FormControlLabel
            control={<Switch
                checked={showFullBracket}
                onChange={e => setShowFullBracket(e.target.checked)}
            />}
            label="Show round of 32"
        />;
    }
    let bracket;
    if (desktopView) {
        if (result.year >= 2026) {
            bracket = <WorldCup32TeamsBracket
                width={42}
                height={28}
                xMargin={28}
                firstRoundYMargin={12}
            />;
        } else {
            bracket = <WorldCup16TeamsBracket
                width={42}
                height={28}
                xMargin={28}
                firstRoundYMargin={28}
            />;
        }
    } else {
        if (result.year >= 2026 && showFullBracket) {
            bracket = <WorldCup32TeamMobileBracket
                width={36}
                height={24}
                xMargin={12}
                firstRoundYMargin={24}
            />;
        } else {
            bracket = <WorldCup16TeamMobileBracket
                width={36}
                height={24}
                xMargin={12}
                firstRoundYMargin={24}
            />;
        }

    }
    return <Box>
        {showFullBracketSwitch}
        <Box overflow="auto">
            {bracket}
        </Box>
    </Box>;
}